import { render, staticRenderFns } from "./Add2.vue?vue&type=template&id=431b138e&scoped=true&"
import script from "./Add2.vue?vue&type=script&lang=js&"
export * from "./Add2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b138e",
  null
  
)

export default component.exports